import { render } from "./green-button.vue?vue&type=template&id=1908d9c7"
import script from "./green-button.vue?vue&type=script&lang=js"
export * from "./green-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__